import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormService } from 'src/app/services/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-additional-services-form',
  templateUrl: './additional-services-form.component.html',
  styleUrls: ['./additional-services-form.component.scss']
})
export class AdditionalServicesFormComponent implements OnInit {

// params
id: number;

// states
formProcessing = false;
isSubmitted = false;
loading = true;

// error messages
formErrors: any = null;
fieldErrors: any = {};

// menu options
commissionCodes: any[] =[];

// endpoints
private _addSvcsEp = `${this._apiSvc.endpoints.sales}/api/AdditionalServiceCode`;

// subscriptions
private _addSvcsSub: Subscription;
private _commissionCodeSub: Subscription;

// form controls
fc = null;

// form group
form: UntypedFormGroup = this._fb.group({
  Id: [null],
  Code: [null, Validators.required],
  IsTaxable: [false],
  CommissionTypeId: [null],
  Description: [null, Validators.required],
  PayCommission: [false],
  StartDate: [this._utilsSvc.todaysDate, Validators.required],
  EndDate: [null]
});

constructor(
  private _apiSvc: ApiService,
  private _authSvc: AuthService,
  private _fb: UntypedFormBuilder,
  private _formSvc: FormService,
  private _route: ActivatedRoute,
  private _router: Router,
  private _toastMsgSvc: ToastMessageService,
  private _utilsSvc: UtilitiesService
) { }

ngOnInit() {

  this.fc = this.form.controls;

  this._route.params.subscribe((params: any) => {

    if (params.id) {
      this.id = params.id;
      this._getRecord();
    } else {
      this.loading = false;
    }

  });

}

ngOnDestroy() {
  if (this._addSvcsSub) {
    this._addSvcsSub.unsubscribe();
  }
  if (this._commissionCodeSub) {
    this._commissionCodeSub.unsubscribe();
  }
}

/**
 * Update form values
 * @param res
 */
private _patchForm(res: any): void {

  this.form.patchValue({
    Id: res.Id,
    Code: res.Code,
    IsTaxable: res.IsTaxable,
    CommissionTypeId: res.CommissionTypeId,
    Description: res.Description,
    PayCommission: res.PayCommission,
    StartDate: res.StartDate,
    EndDate: res.EndDate
  });

}

/**
 * Get additional services record
 */
private _getRecord(): void {

  this._addSvcsSub = this._apiSvc.get(`${this._addSvcsEp}/${this.id}`)
    .subscribe((res: any) => {
      this._patchForm(res);
      this.loading = false;
    });

}


/**
 * Form submission event handler
 * @param e
 */
onSubmit(e: Event): void {

  e.preventDefault();

  this.isSubmitted = false;

  if (!this.form.valid || this.formProcessing) {
    return;
  }

  // clear errors
  this.formErrors = null;
  this.fieldErrors = {};

  this.formProcessing = true;

  const action = this.id ? 'update' : 'add';
  const endpoint = this.id ? `${this._addSvcsEp}/${this.id}` : this._addSvcsEp;

  this._apiSvc[action](endpoint, this.form.value)
    .subscribe((res: any) => {

      this._toastMsgSvc.send({
        type: 'success',
        message: 'Additional service saved',
        icon: 'check_circle_outline'
      });

      this.formProcessing = false;

      // redirect to edit or record list based on permissions
      if (action === 'add') {
        let route = '/configuration/codes/additional-services';
        if (this._authSvc.hasClaim('CodesAdditionalServices', 'Edit')) {
          route  = `${route}/${res.Id}`;
        }
        this._router.navigate([route]);
      }

    }, (err) => {

      const errors = this._formSvc.processFormErrors(err);

      if (errors.formErrors) {
        this.formErrors = errors.formErrors;
      }

      if (errors.fieldErrors) {
        this.fieldErrors = errors.fieldErrors;
      }

      this.formProcessing = false;

    });

  }

}
